import React, {FunctionComponent, useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {applyMiddleware, compose, createStore} from 'redux';
import {createLogger} from 'redux-logger';
import {autoRehydrate, persistStore} from 'redux-persist';
import thunk from 'redux-thunk';
import Loader from './components/Loader';
import App from './pages/App';
import reducers from './reducers';

const middleWares = [thunk];
if (process.env.NODE_ENV === 'development') {
  middleWares.push(createLogger());
}

export const store = createStore(
  reducers,
  compose(autoRehydrate(), applyMiddleware(...middleWares)),
);

const AppProvider: FunctionComponent<{}> = () => {
  const [rehydrated, setRehydrated] = useState(false);

  useEffect(() => {
    if (window.gapi) {
      window.gapi.load('auth2', () => {
        window.gapi.auth2.init({
          client_id:
            '914159990120-i92b5s8pgjng0cat2u8tbje06hdn2i4u.apps.googleusercontent.com',
        });
      });
    }
    persistStore(store, {whitelist: ['authentication', 'groupStorage']}, () => {
      setRehydrated(true);
    });
  }, []);

  if (!rehydrated) return <Loader />;
  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
};

ReactDOM.render(<AppProvider />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.tsx